import * as bh from './badgeHelper';

export const getTypeName = (type) => {
    if (!type) return;

    switch (type) {
        case 'AppointmentBookedNew':
        case 'AppointmentBooked':
        case 'GroupAppointmentBookedNew':
        case 'GroupAppointmentBooked':
            return 'Appointment Booked';

        case 'AppointmentReminderNew':
        case 'AppointmentReminder':
        case 'GroupAppointmentReminderNew':
        case 'GroupAppointmentReminder':
            return 'Appointment Reminder';

        case 'AppointmentConfirmedNew':
        case 'AppointmentConfirmed':
        case 'GroupAppointmentConfirmedNew':
        case 'GroupAppointmentConfirmed':
            return 'Appointment Confirmed';

        case 'AppointmentPrebookReminder':
        case 'GroupAppointmentPrebookReminder':
            return 'Appointment Prebook Reminder';

        case 'OnlineBookingConfirmed':
            return 'Booking Confirmation';

        case 'AppointmentRequestReceived':
            return 'Request an Appointment';

        case 'AppointmentOffer':
            return 'Appointment Offer';

        case 'AppointmentReview':
            return 'Review Request';

        case 'Recall':
            return 'Recall';

        case 'Prescription':
            return 'Prescription';

        case 'ReferralAppointment':
            return 'Referral Appointment Notice';

        case 'Invoice':
            return 'Invoice';

        case 'PaymentReceipt':
            return 'Payment Receipt';

        case 'Quote':
            return 'Quote';

        case 'OrderReady':
            return 'Order is Ready';

        case 'ContactLensReorderReminder':
            return 'Contact Lens Reorder Reminder';

        default:
            return;
    }
}

export const getSubTypeName = (subType) => {
    if (!subType) return;

    switch (subType) {
        case 'Custom':
            return 'Custom';

        case 'AppointmentBooked':
            return 'Appointment Booked';

        case 'AppointmentReminder':
            return 'Appointment Reminder';

        case 'AppointmentConfirmed':
            return 'Appointment Confirmed';

        case 'AppointmentCancelled':
            return 'Appointment Cancelled';

        case 'OnlineBooking':
            return 'Online Booking';

        case 'AppointmentReview':
            return 'Review Request';

        case 'Recall':
            return 'Patient Recall';

        case 'Prescription':
            return 'Patient Prescription';

        case 'ReferralAppointment':
            return 'Referral Appointment';

        case 'Purchase':
            return "Sales and Payments";

        case 'WorkOrder':
            return "Work Order";

        default:
            return;
    }
}

export const getSubTypeDescription = (subType) => {
    if (!subType) return;

    switch (subType) {
        case 'Custom':
            return 'Custom message that can be sent at anytime.';

        case 'AppointmentBooked':
            return 'The first message sent after an appointment is booked.';

        case 'AppointmentReminder':
            return 'Sent prior to the appointment to remind the patient of their visit.';

        case 'AppointmentConfirmed':
            return 'Sent after the patient has confirmed their upcoming appointment.';

        case 'AppointmentCancelled':
            return 'Sent after the patient has cancelled their upcoming appointment.';

        case 'OnlineBooking':
            return 'Messages related to booking or canceling appointments online.';

        case 'AppointmentReview':
            return 'A follow-up message asking the patient to leave a review after their visit.';

        case 'Recall':
            return 'A reminder message for patients who are due for their next appointment.';

        case 'Prescription':
            return 'A message for patients who requested their prescription.';

        case 'ReferralAppointment':
            return 'A message informing patients of their upcoming referral appointment.';

        case 'Purchase':
            return 'A message for patients related to invoices, payment receipts, and quotes.';

        case 'WorkOrder':
            return 'A message related to patient orders that require additional processing.';

        default:
            return;
    }
}

export const getTypeSubTitle = (typeOrName) => {
    switch (typeOrName) {
        case 'Custom':
            return 'Custom message';

        case 'AppointmentBookedNew':
        case 'AppointmentReminderNew':
        case 'AppointmentConfirmedNew':
        case 'AppointmentBooked':
        case 'AppointmentReminder':
        case 'AppointmentConfirmed':
        case 'AppointmentPrebookReminder':
        case 'AppointmentCancelled':
        case 'Appointment Booked (New Patient)':
        case 'Appointment Reminder (New Patient)':
        case 'Appointment Confirmed (New Patient)':
        case 'Appointment Booked':
        case 'Appointment Reminder':
        case 'Appointment Confirmed':
        case 'Appointment Prebook Reminder':
        case 'Appointment Cancelled':
            return 'Individual Appointment';

        case 'GroupAppointmentBookedNew':
        case 'GroupAppointmentReminderNew':
        case 'GroupAppointmentConfirmedNew':
        case 'GroupAppointmentBooked':
        case 'GroupAppointmentReminder':
        case 'GroupAppointmentConfirmed':
        case 'GroupAppointmentPrebookReminder':
        case 'GroupAppointmentCancelled':
        case 'Group Appointment Booked (New Patient)':
        case 'Group Appointment Reminder (New Patient)':
        case 'Group Appointment Confirmed (New Patient)':
        case 'Group Appointment Booked':
        case 'Group Appointment Reminder':
        case 'Group Appointment Confirmed':
        case 'Group Appointment Prebook Reminder':
        case 'Group Appointment Cancelled':
            return 'Group Appointment';

        case 'OnlineBookingConfirmed':
        case 'Online Booking Confirmed':
            return 'Booking Confirmation';

        case 'Online Booking Cancelled':
            return 'Booking Cancelled';

        case 'AppointmentRequestReceived':
        case 'Appointment Request Received':
            return 'Request an Appointment';

        case 'AppointmentOffer':
        case 'Appointment Offer':
            return 'Appointment Offer';

        case 'AppointmentReview':
        case 'Appointment Review':
            return 'Review Request';

        case 'Recall':
            return 'Individual Recall';

        case 'Prescription':
            return 'Prescription';

        case 'ReferralAppointment':
        case 'Referral Appointment':
            return 'Referral Appointment Notice';

        case 'Invoice':
            return 'Invoice';

        case 'PaymentReceipt':
        case 'Payment Receipt':
            return 'Payment Receipt';

        case 'Quote':
            return 'Quote';

        case 'Contact Lens Ready':
            return 'Contact Lens are Ready';

        case 'Eyeglasses Ready':
            return 'Eyeglasses are Ready';

        case 'Sunglasses Ready':
            return 'Sunglasses are Ready';

        case 'OrderReady':
        case 'Order Ready':
            return 'Order is Ready';

        case 'ContactLensReorderReminder':
        case 'Contact Lens Reorder Reminder':
            return 'Contact Lens Reorder';

        default:
            return typeOrName;
    }
}

export const getDisplayBadges = (typeOrName, additionalClassNames) => {
    switch (typeOrName) {
        case 'AppointmentBookedNew':
        case 'AppointmentReminderNew':
        case 'AppointmentConfirmedNew':
        case 'GroupAppointmentBookedNew':
        case 'GroupAppointmentReminderNew':
        case 'GroupAppointmentConfirmedNew':
        case 'Appointment Booked (New Patient)':
        case 'Appointment Reminder (New Patient)':
        case 'Appointment Confirmed (New Patient)':
        case 'Group Appointment Booked (New Patient)':
        case 'Group Appointment Reminder (New Patient)':
        case 'Group Appointment Confirmed (New Patient)':
            return [
                bh.renderAppointmentNew({ isNew: true }, additionalClassNames),
                bh.renderAppointmentFirstExam({ isFirstExam: true, isExamRequired: true }, additionalClassNames)
            ];

        case 'AppointmentBooked':
        case 'AppointmentReminder':
        case 'AppointmentConfirmed':
        case 'AppointmentCancelled':
        case 'GroupAppointmentBooked':
        case 'GroupAppointmentReminder':
        case 'GroupAppointmentConfirmed':
        case 'GroupAppointmentCancelled':
        case 'Appointment Booked':
        case 'Appointment Reminder':
        case 'Appointment Confirmed':
        case 'Appointment Cancelled':
        case 'Group Appointment Booked':
        case 'Group Appointment Reminder':
        case 'Group Appointment Confirmed':
        case 'Group Appointment Cancelled':
            return [bh.renderDefault(additionalClassNames)];

        case 'AppointmentPrebookReminder':
        case 'GroupAppointmentPrebookReminder':
        case 'Appointment Prebook Reminder':
        case 'Group Appointment Prebook Reminder':
            return [bh.renderAppointmentPrebook({ isPrebook: true }, additionalClassNames)];

        default:
            return [];
    }
}